import { lazy, Suspense } from "react";
import { observer } from "mobx-react";

/**
 * The TanStack Query devtools panel, for local development only and only when
 * asked for: start the dev server with `VITE_QUERY_DEVTOOLS=1`. Off by default
 * so its floating toggle never sits over the UI an e2e run or a reviewer sees.
 * A production build drops the import entirely (`import.meta.env.DEV`).
 */
const ReactQueryDevtools =
  import.meta.env.DEV && import.meta.env.VITE_QUERY_DEVTOOLS === "1"
    ? lazy(() =>
        import("@tanstack/react-query-devtools").then((module) => ({
          default: module.ReactQueryDevtools,
        })),
      )
    : null;

export const QueryDevtools = observer(function QueryDevtools() {
  if (!ReactQueryDevtools) return null;
  return (
    <Suspense fallback={null}>
      <ReactQueryDevtools initialIsOpen={false} />
    </Suspense>
  );
});
